import React, { useMemo } from "react";
const RicosDirectionHandledContext = React.createContext(
  null
);
const RicosDirectionHandledContextProvider = ({
  directionHandled,
  children
}) => {
  const directionHandledValue = useMemo(() => {
    return { directionHandled };
  }, [directionHandled]);
  return /* @__PURE__ */ React.createElement(RicosDirectionHandledContext.Provider, { value: directionHandledValue }, children);
};
export {
  RicosDirectionHandledContext,
  RicosDirectionHandledContextProvider
};
//# sourceMappingURL=direction-handled-context.js.map
